import { atom } from 'recoil';

export const contractModalState = atom({
  key: 'contractModalState',
  default: false,
});
